(() => {
  const root = (window.KOMModules = window.KOMModules || {});

  root.setupLanguageDropdown = () => {
    const dropdown = document.querySelector('[data-language-dropdown]');
    if (!dropdown) {
      return;
    }

    const trigger = dropdown.querySelector('.language-trigger');
    if (!trigger) {
      return;
    }

    const close = () => {
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const nextState = !dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open', nextState);
      trigger.setAttribute('aria-expanded', nextState ? 'true' : 'false');
    });

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
      }
    });
  };

  root.setupMobileMenu = () => {
    const overlay = document.getElementById('mobile-menu-overlay');
    const openButton = document.querySelector('.mobile-menu-toggle');
    const closeButton = document.querySelector('.mobile-menu-close');

    if (!overlay || !openButton || !closeButton) {
      return;
    }

    const setOpen = (isOpen) => {
      overlay.hidden = !isOpen;
      openButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('mobile-menu-open', isOpen);
    };

    openButton.addEventListener('click', () => setOpen(true));
    closeButton.addEventListener('click', () => setOpen(false));

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) {
        setOpen(false);
      }
    });

    overlay.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    });
  };

  root.applyRevealAnimations = () => {
    document.documentElement.classList.add('js-ready');
    const revealNodes = Array.from(document.querySelectorAll('.reveal'));

    if (!('IntersectionObserver' in window)) {
      revealNodes.forEach((node) => node.classList.add('in-view'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.01 }
    );

    revealNodes.forEach((node, index) => {
      node.style.transitionDelay = `${Math.min(index * 40, 320)}ms`;
      observer.observe(node);
    });
  };

  root.setupYearStamp = () => {
    const yearNode = document.getElementById('year');
    if (yearNode) {
      yearNode.textContent = `${new Date().getFullYear()}`;
    }
  };
})();
